import "reflect-metadata"
import { injectable } from 'inversify-props';
import { getCFOP, findCFOP } from '@/api/impostos';
import { CFOPServiceAdapter } from '@/usecases';

@injectable()
export class CFOPService implements CFOPServiceAdapter {
	get = async (id: string) => await getCFOP(id)
	find = async (params?: any) => await findCFOP(params)
}